export default "<svg viewBox=\"0 0 13 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m1 1 5.5 6L12 1\"/></svg>";